export const costCentersBulkConfig = {
  tableName: 'cost_centers',
  requiredFields: ['name', 'category_name'],
  fieldMappings: {
    name: {
      type: 'string',
      required: true,
      maxLength: 100,
      label: 'Cost Center Name'
    },
    category_name: {
      type: 'string',
      required: true,
      label: 'Category Name',
      description: 'Name of the category this cost center belongs to. The category will be created automatically if it doesn\'t exist.'
    }
  },
  validateItem: (item) => {
    const errors = [];
    
    // Check that name is provided
    if (!item.name) {
      errors.push('name is required');
    }

    // Check that at least one category field is provided
    const hasCategory = item.category_name || item.categoria || item.category;
    if (!hasCategory) {
      errors.push('category_name (or categoria/category) is required');
    }

    // Validate name length
    if (item.name && item.name.length > 100) {
      errors.push('Cost center name exceeds maximum length of 100 characters');
    }

    // Validate category name length if provided
    const categoryValue = item.category_name || item.categoria || item.category;
    if (categoryValue && categoryValue.length > 100) {
      errors.push('Category name exceeds maximum length of 100 characters');
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  },
  
  // Sample data for template
  sampleData: [
    {
      name: 'Centro Administrativo Principal',
      category_name: 'INSUMOS'
    },
    {
      name: 'Centro Operativo Norte',
      categoria: 'PRODUCCION'
    },
    {
      name: 'Centro Logístico Sur',
      category: 'CALIDAD'
    },
    {
      name: 'Centro Financiero',
      category_name: 'ADMINISTRACION'
    }
  ]
}; 